module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--2--create-8b4caec0.png";